import qs from 'query-string';
import axios from 'api/api.config';
import { useMutation } from 'react-query';

export function useExportProductList() {
  return useMutation(({ queryFilter, bodyFilter }) =>
    axios.post(`/api/v1/admin/product/export?${qs.stringify(queryFilter)}`, bodyFilter).then((res) => res.data)
  );
}
